"use client";

import React from "react";
import { ArrowDownToLine, Droplets, Layers, Activity, Radar, FlaskConical } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Soil Borings",
  description: "High-precision exploratory drilling to retrieve continuous soil samples and define subsurface stratigraphy with absolute accuracy.",
  icon: ArrowDownToLine
}, {
  title: "Groundwater Observations",
  description: "Strategic installation of monitoring wells and piezometers to track critical water table fluctuations and flow dynamics.",
  icon: Droplets
}, {
  title: "Test Pits",
  description: "Direct visual inspection of shallow subsurface conditions with bulk sample collection for comprehensive laboratory validation.",
  icon: Layers
}, {
  title: "In-situ Testing",
  description: "Advanced field measurements including SPT, CPT, and vane shear to assess real-time soil strength and engineering properties.",
  icon: Activity
}, {
  title: "SITE EVALUATION",
  description: "Comprehensive evaluation of soil and subsurface conditions to support site development, foundation design, and permitting requirements.",
  icon: Radar
}, {
  title: "Laboratory Testing",
  description: "Rigorous analytical testing of recovered samples to establish precise index properties, shear strength, and settlement behavior.",
  icon: FlaskConical
}];
export default function SubsurfaceInvestigation() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="137890" id="subsurfaceinvestigation" className="bg-zinc-800 py-24 md:py-32">
      <div className="container mx-auto px-4 md:px-8">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-5xl font-bold uppercase tracking-[0.2em] text-white mb-6">
            Subsurface Investigation
          </h2>
          <p className="text-lg text-zinc-300 leading-relaxed font-sans">
            QST Geotechnical delivers comprehensive subsurface exploration services to accurately characterize soil, rock, and groundwater conditions, providing the technical foundation required for industrial-grade engineering design.
          </p>
        </div>

        <div className="w-full h-12 bg-[#6B28A1] mb-16 border-y border-white/20 flex items-center justify-center" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const {
            ref: cardRef,
            isVisible: isCardVisible
          } = useRevealOnScroll({
            threshold: 0.1
          });
          return <div key={i} data-index={i} ref={cardRef} className={`flex flex-col transition-all duration-700 ease-out h-full ${isCardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="flex-1 rounded-none border border-[#333333] bg-[#1c1c1c] hover:border-[#444444] hover:shadow-2xl transition-all duration-300">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center bg-[#2a2a2a] rounded-none">
                      <service.icon className="h-6 w-6 text-white" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl font-bold uppercase tracking-wider text-white">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-zinc-400 leading-relaxed font-sans">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
                <div className="mt-4 h-1 w-full bg-[#6B28A1]" aria-hidden="true" />
              </div>;
        })}
        </div>
      </div>
    </section>;
}